{
	"choose-region": "Veldu landsvæði",
	"postbox": "Póstbox",
	"postbox-card": {
		"all-day": "Allan sólarhringinn, alla daga ársins",
		"all-day-kringlan": "07-23 virka daga",
		"all-day-kringlan2": "11-23 um helgar",
		"open": "Opið"
	},
	"postoffice": "Pósthús",
	"postoffice-card": {
		"email": "Netfang",
		"opening-hours": "Afgreiðslutímar",
		"phone": "Sími"
	},
	"parcelpoint": "Pakkaport",
	"seeAll": "Sjá allt",
	"search": "Leita",
	"see-list": "Sjá lista",
	"see-map": "Sjá á korti",
	"letter-postboxes": "Póstkassar"
}
